// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { FaWhatsapp } from "react-icons/fa";
// import styles from "./WhatsAppComponent.module.css";

// const WhatsAppComponent = ({
//   selectedTenant,
//   label = "Remind",
//   isDisabled,
// }) => {
//   const history = useNavigate();

//   const finalDisabledState =
//     isDisabled || !selectedTenant || !selectedTenant.mobile;

//   const sendMessageToWhatsApp = () => {
//     if (finalDisabledState) {
//       return;
//     }

//     if (!selectedTenant || !selectedTenant.mobile) {
//       console.error("Mobile number not provided");
//       return;
//     }

//     if (!selectedTenant.hasWhatsApp) {
//       console.error("WhatsApp not available for this contact");
//       const inviteLink = `https://wa.me/+91${selectedTenant.mobile}`;
//       console.log(`Invite link: ${inviteLink}`);
//       window.open(inviteLink, "_blank");
//       return;
//     }

//     if (!selectedTenant.inContactList) {
//       console.log("Contact not in the user's contact list");
//       return;
//     }

//     const message =
//       "Hello You have pending rent to pay. This is a reminder message";

//     const phoneNumber = `+91${selectedTenant.mobile}`;
//     const whatsappUrl = `https://wa.me/+91${phoneNumber}?text=${encodeURIComponent(message)}`;

//     window.open(whatsappUrl, "_blank");
//   };

//   // const divStyle = {
//   //   height: "1.5rem", // h-6
//   //   width: "6rem", // w-20
//   //   borderRadius: "9999px", // rounded-full
//   //   backgroundColor: "transparent", // bg-red-500
//   //   borderWidth: "1px", // border-solid
//   //   borderColor: "blue", // border-solid
//   //   borderStyle: "solid", // border-solid
//   //   display: "flex",
//   //   justifyContent: "center",
//   //   alignItems: "center",
//   //   gap: 2,
//   //   cursor: "pointer",
//   //   color: "blue", // Updated text color to blue
//   // };

//   return (
//     // <div style={divStyle}>
//     //   <FaWhatsapp size={15} />
//     //   <button onClick={sendMessageToWhatsApp}>{label}</button>
//     // </div>
//     <button
//       className={styles.whatsappButton}
//       onClick={sendMessageToWhatsApp}
//       // disabled={!selectedTenant || !selectedTenant.mobile} // Optional: disable button if no tenant/mobile
//       disabled={finalDisabledState}
//       title={label} // Good for accessibility
//     >
//       <FaWhatsapp size={18} className={styles.icon} />
//       <span>{label}</span>
//     </button>
//   );
// };

// export default WhatsAppComponent;

// src/components/YourPath/WhatsAppComponent.jsx

// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { FaWhatsapp } from "react-icons/fa";

// const WhatsAppComponent = ({
//   selectedTenant,
//   label = "Remind",
//   isDisabled,
// }) => {
//   const history = useNavigate();
//   const finalDisabledState =
//     isDisabled || !selectedTenant || !selectedTenant.mobile;

//   // --- Use the EXACT SAME style strings for perfect sync ---
//   const baseButtonStyles =
//     "flex items-center justify-center w-24 h-6 gap-1.5 text-xs font-medium border rounded-full transition-colors duration-200";

//   const enabledStyles =
//     "border-blue-500 text-blue-500 hover:bg-blue-50 cursor-pointer";

//   const disabledStyles =
//     "border-gray-400 text-gray-400 border-dotted opacity-80 cursor-not-allowed";

//   // To keep the WhatsApp brand color when enabled, but greyed out when disabled.
//   const iconColor = finalDisabledState ? "text-gray-400" : "text-green-500";

//   const sendMessageToWhatsApp = () => {
//     if (finalDisabledState) return;

//     const message =
//       "Hello You have pending rent to pay. This is a reminder message";
//     const phoneNumber = `+91${selectedTenant.mobile}`;
//     const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
//     window.open(whatsappUrl, "_blank");
//   };

//   return (
//     <button
//       onClick={sendMessageToWhatsApp}
//       disabled={finalDisabledState}
//       title={
//         finalDisabledState
//           ? "Cannot remind until previous dues are cleared"
//           : label
//       }
//       // Combine the style strings, just like in the Paid component
//       className={`${baseButtonStyles} ${finalDisabledState ? disabledStyles : enabledStyles}`}
//     >
//       <FaWhatsapp size={15} className={iconColor} />
//       <span>{label}</span>
//     </button>
//   );
// };

// export default WhatsAppComponent;

// src/components/YourPath/WhatsAppComponent.jsx

// src/components/YourPath/WhatsAppComponent.jsx
import React from "react";
// import { FaWhatsapp } from "react-icons/fa";

// const WhatsAppComponent = ({
//   selectedTenant,
//   label = "Remind",
//   isDisabled,
// }) => {
//   const finalDisabledState =
//     isDisabled || !selectedTenant || !selectedTenant.mobile;

//   // The 'group' class here also makes this button a self-contained hover target.
//   const baseButtonStyles =
//     "group flex items-center justify-center w-24 h-6 gap-1.5 text-xs font-medium border rounded-full transition-all duration-300";

//   const enabledStyles =
//     "border-green-500 text-green-500 hover:bg-green-500 hover:border-green-500 cursor-pointer";

//   const disabledStyles =
//     "border-gray-400 text-gray-400 border-dotted opacity-80 cursor-not-allowed";

//   const iconColor = finalDisabledState
//     ? "text-gray-400"
//     : "text-green-500 group-hover:text-white";

//   const sendMessageToWhatsApp = (event) => {
//     event.stopPropagation();
//     if (finalDisabledState) return;

//     const message =
//       "Hello You have pending rent to pay. This is a reminder message";
//     const phoneNumber = `+91${selectedTenant.mobile}`;
//     const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
//     window.open(whatsappUrl, "_blank");
//   };

//   return (
//     <button
//       onClick={sendMessageToWhatsApp}
//       disabled={finalDisabledState}
//       title={finalDisabledState ? "Cannot remind..." : label}
//       className={`${baseButtonStyles} ${finalDisabledState ? disabledStyles : enabledStyles}`}
//     >
//       <FaWhatsapp
//         size={15}
//         className={`transition-colors duration-300 ${iconColor}`}
//       />
//       {/* This group-hover now correctly refers to hovering this specific button */}
//       <span
//         className={`${finalDisabledState ? "text-gray-400" : "text-green-500"} group-hover:text-white transition-colors duration-300 `}
//       >
//         {label}
//       </span>
//     </button>
//   );
// };

// export default WhatsAppComponent;

// components/Buttons/WhatsAppComponent.jsx

// import { FaWhatsapp } from "react-icons/fa";

// const WhatsAppComponent = ({
//   mobile,
//   message, // 🔥 ADDED: Accept a dynamic message
//   label = "Remind",
//   isDisabled = false, // Default to false
// }) => {
//   // A tenant must have a mobile number and a message must be provided.
//   const finalDisabledState = isDisabled || !mobile || !message;

//   const baseButtonStyles =
//     "group flex items-center justify-center w-24 h-6 gap-1.5 text-xs font-medium border rounded-full transition-all duration-300";
//   const enabledStyles =
//     "border-green-500 text-green-500 hover:bg-green-500 hover:text-white cursor-pointer";
//   const disabledStyles =
//     "border-gray-400 text-gray-400 border-dotted opacity-80 cursor-not-allowed";

//   const iconColor = finalDisabledState
//     ? "text-gray-400"
//     : "text-green-500 group-hover:text-white";

//   const sendMessageToWhatsApp = (event) => {
//     event.stopPropagation(); // Prevent row click or other parent events
//     if (finalDisabledState) return;

//     // Use the dynamic message prop
//     const phoneNumber = `+91${mobile}`;
//     const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
//       message
//     )}`;
//     window.open(whatsappUrl, "_blank");
//   };

//   return (
//     <button
//       onClick={sendMessageToWhatsApp}
//       disabled={finalDisabledState}
//       title={finalDisabledState ? "Cannot remind: Missing data" : label}
//       className={`${baseButtonStyles} ${
//         finalDisabledState ? disabledStyles : enabledStyles
//       }`}
//     >
//       <FaWhatsapp
//         size={15}
//         className={`transition-colors duration-300 ${iconColor}`}
//       />
//       <span
//         className={`${
//           finalDisabledState ? "text-gray-400" : "text-green-500"
//         } group-hover:text-white transition-colors duration-300`}
//       >
//         {label}
//       </span>
//     </button>
//   );
// };

// export default WhatsAppComponent;

import { FaWhatsapp } from "react-icons/fa";

const WhatsAppComponent = ({
  selectedTenant,
  // mobile,
  // message,
  label = "Remind",
  isDisabled = false,
  disabledReason = "", // 🔥 ADDED: A prop for the specific disabled message
}) => {
  const mobile = selectedTenant?.mobile;
  const firstName = selectedTenant?.first_name;
  const month = selectedTenant?.month;
  const year = selectedTenant?.year;
  const localAmount = selectedTenant?.local_amount;

  const message =
    firstName && month && year && localAmount
      ? `Hello ${firstName}. This is a friendly reminder for your payment of ${localAmount} for ${month} ${year}, which is due soon. Thank you.`
      : "";

  // This logic correctly determines if the button should be non-functional
  const finalDisabledState = isDisabled || !mobile || !message;

  // 🔥 NEW: Helper function to determine the tooltip text dynamically
  const getTooltipText = () => {
    if (!finalDisabledState) {
      return label; // If enabled, show the standard label
    }

    // If the parent explicitly disabled it AND provided a reason, use that.
    // This is the highest priority and solves your issue.
    if (isDisabled && disabledReason) {
      return disabledReason;
    }

    // Fallback for when it's disabled due to missing internal data.
    if (!mobile || !message) {
      return "Cannot Remind: Missing data (mobile, name or amount).";
    }

    // A generic fallback if it's disabled by the parent without a specific reason.
    return "This action is currently disabled.";
  };

  const baseButtonStyles =
    "group flex items-center justify-center w-24 h-6 gap-1.5 text-xs font-medium border rounded-full transition-all duration-300";
  const enabledStyles =
    "border-green-500 text-green-500 hover:bg-green-500 hover:text-white cursor-pointer";
  const disabledStyles =
    "border-gray-400 text-gray-400 border-dotted opacity-80 cursor-not-allowed";

  const iconColor = finalDisabledState
    ? "text-gray-400"
    : "text-green-500 group-hover:text-white";

  const sendMessageToWhatsApp = (event) => {
    event.stopPropagation(); // Prevent row click
    if (finalDisabledState) return;

    const phoneNumber = `+91${mobile}`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <button
      onClick={sendMessageToWhatsApp}
      disabled={finalDisabledState}
      // 🔥 UPDATED: Use the new helper function for the tooltip
      title={getTooltipText()}
      className={`${baseButtonStyles} ${
        finalDisabledState ? disabledStyles : enabledStyles
      }`}
    >
      <FaWhatsapp
        size={15}
        className={`transition-colors duration-300 ${iconColor}`}
      />
      <span
        className={`${
          finalDisabledState ? "text-gray-400" : "text-green-500"
        } group-hover:text-white transition-colors duration-300`}
      >
        {label}
      </span>
    </button>
  );
};

export default WhatsAppComponent;
